export const getters = {
  systemTarrifs: state => state.tarrifs,
  Tarrif: state => state.systemTarrif
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/tarrifs/getters.js